<template>
    <div class="scc-contact" :class="`scc-contact--${backgroundColor}`">
        <p class="scc-contact__title h4">{{ title }}</p>
        <p class="scc-contact__text">{{ text }}</p>
        <div class="scc-contact__links">
            <div v-for="(link, i) in links" :key="i" class="scc-contact__link">
                <div class="scc-contact__link-icon"></div>
                <SccLink :to="link.link">
                    {{ link.name }}
                </SccLink>
            </div>
        </div>
    </div>
</template>

<script>
import './contact.scss';
import SccLink from './SccLink';

export default {
    name: 'Contact',
    components: {
        SccLink,
    },
    __editor: {
        fields: {
            text: {
                widget: 'textarea',
            },
            backgroundColor: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'white'],
            },
            links: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        name: {
                            widget: 'text',
                        },
                        link: {
                            widget: 'text',
                        },
                    },
                },
            },
        },
    },
    props: {
        title: String,
        text: String,
        backgroundColor: {
            type: String,
            required: false,
            default: 'white',
            validator: function(val) {
                return ['primary', 'secondary', 'body', 'white'].includes(val);
            },
        },
        links: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
